module.exports = __webpack_public_path__ + "img/upload-more.5ba40f16.svg";